import { render, staticRenderFns } from "./ModalPatientInfo.vue?vue&type=template&id=18594963&scoped=true"
import script from "./ModalPatientInfo.vue?vue&type=script&lang=js"
export * from "./ModalPatientInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientInfo.vue?vue&type=style&index=0&id=18594963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18594963",
  null
  
)

export default component.exports